/* eslint-disable react-hooks/exhaustive-deps */
import { useState, createContext, useContext, useMemo, useEffect } from "react";
import {
  ExpenseLiabilityConstant,
  ExpensesConstant,
  GameStates,
  LiabilityConstant,
} from "../utility/game";
import {
  BoardPositions,
  InnerBoardBoxType,
  OuterBoardBoxType,
  OuterBoardPositions,
} from "../utility/board";
import {
  getInnerGameState,
  rollDie,
  DealTypes,
  calculateCash,
  FirebaseService,
  adjustNewLiability,
  adjustNewExpense,
  roundNumber,
  getFastTrackGameState,
  getRandomCashflow,
  playAudio,
  DataClass,
  getStockSplitFactor,
  createShuffledDecks,
  getCardFromDeck,
} from "../utility";
import { useAuth } from "./auth";
import { useObjectVal } from "react-firebase-hooks/database";
import { ref, update } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { AudioConstant } from "../audio";
import { toast } from "react-toastify";

const GameContext = createContext();

export function GameProvider({ children }) {
  const { user } = useAuth();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [highlightedRows, setHighlightedRows] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [roomId, setRoomId] = useState(null);
  const [room] = useObjectVal(ref(FirebaseService.database, `rooms/${roomId}`));
  const navigate = useNavigate();

  const { gameState, turnData } = room || {};

  const updatePlayer = async (newInfo, updateUser) => { 
    const tempUser = updateUser ? updateUser: currentPlayer   
    const temp = {
      ...tempUser,
      ...newInfo,
    };
    const calculatedFields = calculateCash(temp);    
    await update(
      ref(FirebaseService.database, `rooms/${roomId}/players/${user.uid}`),
      {
        ...temp,
        ...calculatedFields,
      },
    );    
  };
 

  const { yourTurn, players, currentPlayer, allOut } = useMemo(() => {
    const tempPlayer = Object.values(room?.players || {});
    return {
      yourTurn: room?.currentTurn === user?.uid,
      players: tempPlayer,
      currentPlayer: tempPlayer.find((x) => x.id === room?.currentTurn),
      allOut: tempPlayer.length > 0 && tempPlayer.every((x) => x.lose),
    };
  }, [room, user, updatePlayer]);

  useEffect(() => {
    const update = async () => {
      await updateRoom({
        completed: true,
      });
    };
    if (allOut) {
      update();
    }
  }, [allOut]);

  const updateRoom = async (newValue) => {
    await update(ref(FirebaseService.database, `rooms/${roomId}`), newValue);
  };

  const drawCard = async (deckName, deriveExtra) => {
    const existingDecks = room?.decks;
    let deck = existingDecks?.[deckName];
    let decksUpdate = null;
    if (!deck || !deck.order?.length) {
      const fresh = createShuffledDecks();
      decksUpdate = { ...(existingDecks || {}), ...fresh };
      deck = decksUpdate[deckName];
    }
    const card = getCardFromDeck(deckName, deck);
    const nextIndex = ((deck.index || 0) + 1) % deck.order.length;
    const updatedDeck = { order: deck.order, index: nextIndex };
    const decksToWrite = decksUpdate
      ? { ...decksUpdate, [deckName]: updatedDeck }
      : { ...(existingDecks || {}), [deckName]: updatedDeck };
    const extra = typeof deriveExtra === "function" ? deriveExtra(card) || {} : {};
    await updateRoom({ decks: decksToWrite, ...extra });
    return card;
  };

  const leaveTheLobby = async () => {
    if (yourTurn && !currentPlayer?.winner) {
      await nextTurn(true);
    } 
    await update(
      ref(FirebaseService.database, `rooms/${roomId}/players/${user.uid}`),
      {
        left: true,
      },
    );    
    navigate("/rooms");
  };

  const kickOutUser = async (tempUser) => {
    if (currentPlayer.id === tempUser.id) {
      await update(
        ref(FirebaseService.database, `rooms/${roomId}/players/${tempUser.id}`),
        {
          left: true,
        },
      );
      await nextTurn();
    }
  };

  const getNextTurnUser = () => {    
    let currentPlayerIndex = players.findIndex(
      (x) => x.id === room?.currentTurn
    );
    let nextPlayerIndex = (currentPlayerIndex + 1) % players.length;
    const tempPlayers = players.filter((x) => !x.lose && !x.left);
    // if (currentPlayerIndex < tempPlayers.length - 1) {
    //   currentPlayerIndex += 1;
    // } else {
    //   currentPlayerIndex = 0;
    // }
    if(tempPlayers.length > 1){
      while (players[nextPlayerIndex]?.lose || players[nextPlayerIndex]?.left) {
        nextPlayerIndex = (nextPlayerIndex + 1) % players.length;
      }
    }
    return players[nextPlayerIndex];
  };

  const nextTurn = async (isLeft) => {  
    console.log("players",players)   
    let tempPlayers = players.filter((x) => !x.lose && !x.left);
    let gameState = GameStates.turn
    if(isLeft){
      tempPlayers = tempPlayers.filter((x) => x.id !== currentPlayer?.id)
    }  
    if (tempPlayers.length > 1) {
      playAudio(AudioConstant.nextPlayer, currentPlayer);
    }
    else if(tempPlayers.length === 1 && players.length > 1){
        await update(
          ref(FirebaseService.database, `rooms/${roomId}/players/${tempPlayers[0]?.id}`),
          {
            winner: true,
          },
        );
        gameState = GameStates.winner
    }   
    await updateRoom({
      currentTurn: getNextTurnUser().id,
      gameState
    });
    
  };

  

  const movePlayer = async (dieCount) => {
    const previousPosition = currentPlayer.position;
    const { dice, total } = rollDie(dieCount);
    playAudio(AudioConstant.roll,currentPlayer);
    await updateRoom({
      lastRoll: {
        dice,
        total,
        playerId: currentPlayer.id,
        playerName: currentPlayer.name,
        rolledAt: Date.now(),
      },
    });
    let newPosition = total + previousPosition;

    let hasPayDay = [];
    if (currentPlayer.fastTrack) {
      if (newPosition > OuterBoardPositions.length - 1) {
        newPosition = newPosition - OuterBoardPositions.length;
        hasPayDay = OuterBoardPositions.filter(
          (x, index) =>
            x.type === OuterBoardBoxType.cashflow &&
            index <= newPosition
        );
        
      } else {
        hasPayDay = OuterBoardPositions.filter(
          (x, index) =>
            x.type === OuterBoardBoxType.cashflow &&
            index > previousPosition &&
            index <= newPosition,
        );
      }
    } else {
      if (newPosition > BoardPositions.length - 1) {
        
        hasPayDay = BoardPositions.filter(
          (x, index) =>
            x.type === InnerBoardBoxType.payday &&
            index >= previousPosition &&
            index < newPosition

        );        
        newPosition = newPosition - BoardPositions.length;
      } else {
        hasPayDay = BoardPositions.filter(
          (x, index) =>
            x.type === InnerBoardBoxType.payday &&
            index >= previousPosition &&
            index < newPosition
        );
      }
    }    
    

    const temp = {
      position: newPosition,
    };
    if (currentPlayer.charityTurns > 0) {
      temp.charityTurns = currentPlayer.charityTurns - 1;
    }
    if (hasPayDay.length > 0) {
      temp.cash =
        currentPlayer.cash +
        (currentPlayer.fastTrack
          ? currentPlayer.cashFlowDay
          : currentPlayer.payday * hasPayDay.length);
    }
    await updatePlayer(temp);
    playAudio(AudioConstant.statementOpen, currentPlayer);
    setOpenDrawer(true);

    if (currentPlayer.fastTrack) {
      const newGameState = getFastTrackGameState(newPosition);
      let ftBox = {};
      if (newGameState === GameStates.opportunity) {
        ftBox = {
          ...OuterBoardPositions[newPosition],
          cashFlow: getRandomCashflow(),
        };
        delete ftBox.icon;
      } else if (newGameState === GameStates.ftDoodad) {
        ftBox = {
          ...OuterBoardPositions[newPosition],
          cost: Math.floor(currentPlayer?.cash / 2),
        };
        delete ftBox.icon;
      }

      playAudio(AudioConstant[newGameState],currentPlayer);
      await updateRoom({
        gameState: newGameState,
        ftBox,
      });
    } else {
      const newGameState = getInnerGameState(newPosition);
      playAudio(AudioConstant[newGameState],currentPlayer);
      await updateRoom({
        gameState: newGameState,
      });
    }
  };

  const payExpenses = async (type, expense) => {
    try {
      playAudio(AudioConstant.human,currentPlayer);
      if (expense) {
        let cost = expense.cost || 0;
        const temp = {
          expenses: [...(currentPlayer.expenses || [])],
          liabilities: [...(currentPlayer.liabilities || [])],
        };
        if (expense.amount) {
          cost = currentPlayer.cash * expense.amount;
        }
        if (expense.loan && expense.key) {
          temp.liabilities.push({
            id: Math.random(),
            name: LiabilityConstant[expense.key] || expense.name,
            key: expense.key,
            value: expense.loan,
          });
        }
        if (expense.payment && expense.key) {
          temp.expenses = adjustNewExpense(temp.expenses, {
            name: LiabilityConstant[expense.key] || expense.name,
            key: expense.key,
            value: expense.payment,
          });
        }
        if (expense.debt && expense.key) {
          temp.liabilities = adjustNewLiability(temp.liabilities, {
            id: Math.random(),
            name: LiabilityConstant[expense.key] || expense.name,
            key: expense.key,
            value: expense.debt,
          });
        }

        switch (type) {
          case GameStates.baby:
            temp.children = currentPlayer.children + 1;
            const perChild = currentPlayer.perChildCost || cost;
            const newChildrenExpense = perChild * temp.children;
            const existingChildren = temp.expenses.find((x) => x.key === "children");
            if (existingChildren) {
              temp.expenses = temp.expenses.map((x) =>
                x.key === "children" ? { ...x, value: newChildrenExpense } : x
              );
            } else {
              temp.expenses = [
                ...temp.expenses,
                { name: ExpensesConstant.children, key: "children", value: newChildrenExpense },
              ];
            }
            break;

          case GameStates.downsized:
            temp.downsizedTurns = currentPlayer.downsizedTurns + 2;
            break;

          case GameStates.charity:
            temp.charityTurns = currentPlayer.charityTurns + 3;
            break;

          default:
            break;
        }

        if (cost <= currentPlayer.cash) {
          temp.cash = currentPlayer.cash - cost;
          await updatePlayer({
            ...temp,
          });
          if(expense?.name !== "DiesExpired" && currentPlayer.dream){
            await finishTurn({
              ...currentPlayer,
              ...temp,
            });
          }
        } else {
          await updateRoom({
            turnData: {
              type,
              cost,
              gameState,
              data: expense,
            },
            gameState: GameStates.takeALoan,
          });
        }
      } else {
        await finishTurn();
      }
    } catch (err) {
      console.error("payExpenses error:", err);
      toast.error("Something went wrong processing this card. Please try again.");
    }
  };

  const buyDeal = async (deal) => {
    playAudio(AudioConstant.human,currentPlayer);

    let cost;
    if (
      [
        DealTypes.realEstate,
        DealTypes.limitedPartnership,
        DealTypes.business,
      ].includes(deal.type)
    ) {
      cost = deal.downPayment ?? deal.cost ?? 0;
    } else {
      cost = deal.cost || deal.price * deal.shares || 0;
    }

    const temp = {
      stockAssets: [...(currentPlayer.stockAssets || [])],
      realEstateAssets: [...(currentPlayer.realEstateAssets || [])],
      liabilities: [...(currentPlayer.liabilities || [])],
    };

    if (cost <= currentPlayer.cash) {
      temp.cash = currentPlayer.cash - cost;
      if (
        [
          DealTypes.realEstate,
          DealTypes.limitedPartnership,
          DealTypes.business,
          DealTypes.company,
        ].includes(deal.type)
      ) {
        const asset = { ...deal };
        if (asset.downPayment && asset.cost) {
          const loanAmount = asset.cost - asset.downPayment;
          if (deal.type === DealTypes.realEstate) {
            asset.mortgage = loanAmount;
          } else {
            asset.liability = loanAmount;
          }
        }
        temp.realEstateAssets = [
          ...temp.realEstateAssets,
          asset,
        ];
      } else {
        if (temp.stockAssets.some((x) => x.symbol === deal.symbol)) {
          temp.stockAssets = temp.stockAssets.map((x) => {
            if (x.symbol === deal.symbol) {
              const totalShares = x.shares + deal.shares;
              const totalCost = x.cost + cost;
              return {
                ...x,
                shares: totalShares,
                price: Math.round(totalCost / totalShares),
                cost: totalCost,
              };
            }
            return x;
          });
        } else {
          temp.stockAssets = [
            ...temp.stockAssets,
            {
              ...deal,
              cost,
            },
          ];
        }
      }
      await updatePlayer({
        ...temp,
      });
      await finishTurn({
        ...currentPlayer,
        ...temp,
      });
    } else {
      await updateRoom({
        turnData: {
          cost,
          gameState,
          data: deal,
        },
        gameState: GameStates.takeALoan,
      });
    }
  };

  const applyStockSplit = async (deal) => {
    playAudio(AudioConstant.human, currentPlayer);
    const factor = getStockSplitFactor(deal);
    const stockAssets = (currentPlayer.stockAssets || []).map((x) => {
      if (x.symbol !== deal.symbol) return x;
      const newShares = Math.max(0, Math.floor(x.shares * factor));
      const newPrice =
        newShares > 0 ? Math.round(x.cost / newShares) : x.price;
      return {
        ...x,
        shares: newShares,
        price: newPrice,
      };
    }).filter((x) => x.shares > 0);

    await updatePlayer({ stockAssets });
    await finishTurn({ ...currentPlayer, stockAssets });
  };

  const sellDeal = async (deal) => {
    playAudio(AudioConstant.human,currentPlayer);
    const cost = deal.price * deal.shares;
    const stockAssets = currentPlayer.stockAssets
      .map((x) => {
        if (x.symbol === deal.symbol) {
          const boughtCost = x.price * deal.shares;
          const totalShares = x.shares - deal.shares;
          const updatedCost = x.cost - boughtCost;
          return {
            ...x,
            shares: totalShares,
            cost: updatedCost,
          };
        }
        return x;
      })
      .filter((x) => x.shares > 0);

    await updatePlayer({
      cash: currentPlayer.cash + cost,
      stockAssets,
    });
    await finishTurn();
  };

  const loanDecision = async (loanAmount) => {
    playAudio(AudioConstant.human,currentPlayer);
    if (loanAmount) {
      const temp = {
        expenses: [...currentPlayer.expenses],
        liabilities: [...(currentPlayer.liabilities || [])],
      };

      temp.liabilities = adjustNewLiability(temp.liabilities, {
        name: LiabilityConstant.loans,
        key: "loans",
        value: loanAmount,
        id: Math.random(),
      });
      temp.expenses = adjustNewExpense(temp.expenses, {
        name: ExpensesConstant.loans,
        key: "loans",
        value: roundNumber(loanAmount * 0.1),
      });
      temp.cash = currentPlayer.cash + loanAmount;
      await updatePlayer({
        ...temp,
      });
    }
    await updateRoom({
      gameState: turnData.gameState,
    });
  };

  const checkBalanceSheet = (currentPlayerInfo) => {
    if (currentPlayerInfo.payday < 0 && currentPlayerInfo.cash < 0) {
      if (
        (currentPlayerInfo.realEstateAssets || []).filter(
          (x) => (x.downPayment || 0) > 0,
        ).length > 0
      ) {
        return GameStates.bankrupt;
      }
      return GameStates.lose;
    }
  };

  const finishTurn = async (currentPlayerInfo) => {
    const tempPlayer = currentPlayerInfo || currentPlayer;
    let newState;
    if (tempPlayer.fastTrack) {
      if (tempPlayer.passiveIncome >= tempPlayer.winGoal) {
        newState = GameStates.winner;
        await updatePlayer({
          winner: true,
        });
        await updateRoom({
          gameState: GameStates.winner,
          turnData: null,
          deal: null,
          offer: null,
          doodad: null,
        });
        return;
      }
    } else {
      if (tempPlayer.passiveIncome > tempPlayer.totalExpenses) {
        newState = GameStates.outOfRatRace;
      } else {
        newState = checkBalanceSheet(tempPlayer);
      }
    }
    await updateRoom({
      gameState: newState || GameStates.finishTurn,
      turnData: null,
      deal: null,
      offer: null,
      doodad: null,
    });
    setOpenDrawer(!!newState);
    if (newState !== GameStates.bankrupt) {
      setHighlightedRows({});
    }
    setSelectedRow(null);
    if (newState === GameStates.lose) {
      await updatePlayer({
        lose: true,
      });
    } else if (newState === GameStates.outOfRatRace) {
      await updatePlayer({
        fastTrack: true,
      });
    }
  };

  const repay = async () => {
    await updateRoom({
      gameState: GameStates.repay,
      turnData: null,
    });
    const temp = {};
    (currentPlayer.liabilities || []).forEach(
      (item) => (temp[item.id] = "highlighed"),
    );
    playAudio(AudioConstant.statementOpen,currentPlayer);
    setOpenDrawer(true);
    updateHighlightAssets(temp);
  };

  const payoffLoan = async (liability, amount) => {
    let newLiabilities = [];
    let newExpenses = [];
    playAudio(AudioConstant.human,currentPlayer);
    if (liability.key === "loans") {
      newLiabilities = (currentPlayer.liabilities || [])
        .map((x) => {
          if (x.id === liability.id) {
            return {
              ...x,
              value: x.value - amount,
            };
          }
          return x;
        })
        .filter((x) => x.id !== liability.id || x.value > 0);

      const loadInterest = Math.round(amount * 0.1);
      const expenseName = ExpenseLiabilityConstant[liability.key.toLowerCase()];
      newExpenses = currentPlayer.expenses
        .map((x) => {
          if (x.name === expenseName) {
            return {
              ...x,
              value: x.value - loadInterest,
            };
          }
          return x;
        })
        .filter((x) => x.name !== expenseName || x.value > 0);
    } else {
      newLiabilities = (currentPlayer.liabilities || [])
        .map((x) => x.id === liability.id ? { ...x, value: 0 } : x)
        .filter((x) => x.id !== liability.id || x.value > 0);
      newExpenses = (currentPlayer.expenses || [])
        .map((x) => x.key === liability.key ? { ...x, value: 0 } : x)
        .filter((x) => x.key !== liability.key || x.value > 0);
    }

    await updatePlayer({
      cash: currentPlayer.cash - (amount || liability.value),
      liabilities: newLiabilities,
      expenses: newExpenses,
    });

    await finishTurn();
  };

  const dealDecision = async (state) => {
    playAudio(AudioConstant.human,currentPlayer);
    await updateRoom({
      gameState: state,
    });
  };

  const borrow = async () => {
    playAudio(AudioConstant.human,currentPlayer);
    await updateRoom({
      gameState: GameStates.takeALoan,
      turnData: {
        gameState,
      },
    });
    playAudio(AudioConstant.statementOpen,currentPlayer);
    setOpenDrawer(true);
  };

  const updateHighlightAssets = (highlighed) => {
    setHighlightedRows({ ...highlighed });
  };

  const updateSelectedRow = (assest) => {
    setSelectedRow(assest);
  };

  const acceptOffer = async (deal, amount, skipFinishTurn = false) => {
    playAudio(AudioConstant.human,currentPlayer);
    let incoming;
    const temp = {};
    const liability = selectedRow.mortgage || selectedRow.liability || 0;
    if (amount) {
      incoming = amount;
    } else if (deal.offerPerUnit) {
      incoming = deal.offerPerUnit * (selectedRow.units || 0) - liability;
    } else {
      incoming = (deal.offer || 0) - liability;
    }
    temp.cash = currentPlayer?.cash + incoming;
    temp.realEstateAssets = (currentPlayer?.realEstateAssets || []).filter(
      (x) => x.id !== selectedRow.id,
    );
    await updatePlayer({
      ...temp
    });
    if (!skipFinishTurn) {
      await finishTurn({
        ...currentPlayer,
        ...temp,
      });
    }
  };


  // Fast Track Functions
  const setupFastTrack = async () => {
    playAudio(AudioConstant.human,currentPlayer);
    const playerDream = DataClass.dreams.find((d) => d.text === currentPlayer.dream);
    const dreamCost = playerDream?.cost || 50000;
    const temp = {
      cash: currentPlayer.passiveIncome * 100,
      cashFlowDay: currentPlayer.passiveIncome * 100,
      initialCashFlowDay: currentPlayer.passiveIncome * 100,
      winGoal: (currentPlayer.passiveIncome * 100) + dreamCost,
      position: 2,
      downsizedTurns: 0,
      charityTurns: 0,
      realEstateAssets: [],
      stockAssets: [],
      personalAssets: [],
      liabilities: [],
      fastTrackAssets: [],
      expenses: [],
    };



    const calculatedFields = calculateCash({
      ...currentPlayer,
      ...temp,
    });

    await updatePlayer({
      ...temp,
      ...calculatedFields,
    });
    await nextTurn();
  };

  const buyOpportunity = async (opportunity) => {
    let cost = opportunity.cost || 0;

    const temp = {
      fastTrackAssets: [...(currentPlayer.fastTrackAssets || [])],
    };

    temp.cash = currentPlayer.cash - cost;

    temp.fastTrackAssets = [
      ...temp.fastTrackAssets,
      {
        ...opportunity,
      },
    ];
    await updatePlayer({
      ...temp,
    });
    await finishTurn({
      ...currentPlayer,
      ...temp,
    });
  };

  const turnExpired = async () => {
    await updateRoom({
      currentTurn: getNextTurnUser().id,
      gameState: GameStates.turnExpired,
    });
  };

  const contextData = useMemo(
    () => ({
      players,
      currentPlayer,
      gameState,
      yourTurn,
      rollDie,
      movePlayer,
      updatePlayer,
      turnData,
      nextTurn,
      payExpenses,
      buyDeal,
      sellDeal,
      applyStockSplit,
      loanDecision,
      openDrawer,
      setOpenDrawer,
      updateHighlightAssets,
      selectedRow,
      updateSelectedRow,
      acceptOffer,
      highlightedRows,
      borrow,
      repay,
      finishTurn,
      setRoomId,
      dealDecision,
      payoffLoan,
      updateRoom,
      room,
      allOut,
      leaveTheLobby,
      kickOutUser,
      setupFastTrack,
      buyOpportunity,
      getNextTurnUser,
      turnExpired,
      drawCard,
    }),
    [
      players,
      currentPlayer,
      gameState,
      yourTurn,
      rollDie,
      movePlayer,
      updatePlayer,
      nextTurn,
      payExpenses,
      buyDeal,
      sellDeal,
      applyStockSplit,
      turnData,
      loanDecision,
      openDrawer,
      setOpenDrawer,
      updateHighlightAssets,
      selectedRow,
      updateSelectedRow,
      acceptOffer,
      highlightedRows,
      borrow,
      repay,
      finishTurn,
      setRoomId,
      dealDecision,
      payoffLoan,
      updateRoom,
      room,
      allOut,
      leaveTheLobby,
      kickOutUser,
      setupFastTrack,
      buyOpportunity,
      getNextTurnUser,
      turnExpired,
      drawCard,
    ],
  );
  return (
    <GameContext.Provider value={contextData}>{children}</GameContext.Provider>
  );
}

export const useGame = () => useContext(GameContext);
